import { call, put, take, select } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import RecentListActions from '../reducers/recentListReducer'
import firebase from '../config/firebase'

export function* getRecentLists() {
  const { region } = yield select(state => state.auth.data)
  const database = firebase.database()
  const recentStoreRef = database.ref('recent_lists').orderByChild('region').equalTo(region)
  const databaseEventChannel = yield call(observerEvent, recentStoreRef) // listening databaseEvent

  try {
    while (true) {
      const recentLists = yield take(databaseEventChannel) // take event data
      yield put(RecentListActions.getRecentListsConnected(recentLists))
    }
  } catch (error) {
    yield put(RecentListActions.getRecentListsError(error))
  } finally {
    databaseEventChannel.close();
  }
}

const observerEvent = ref => {
  const listener = eventChannel(emit => {
    ref.on('value', data => {
      if (data.val() !== null) {
        let list = {}
        data.forEach((res) => { list[res.key] = { ...res.val(), key: res.key } })
        emit(list)
      } else {
        emit({})
      }
    })

    return () => {
      ref.off()
    }
  });

  return listener
};




// WEBPACK FOOTER //
// ./src/sagas/recentListSaga.js